
@for(group of tagsGroupList(); track group.id) {
  <section class="tags__group">
    <div class="group__wrapper">
      <div class="group__title-wrapper">
        <ci-icon 
          class="group__icon"
          type="svg" 
          name="shopping-mode" 
          scale="1.5x"
        ></ci-icon>
        
        <h3 class="ci-heading-h3-s-bold group__title">
          {{ group.name[currentLang] }}
        </h3>
      </div>

      <ci-chip-set 
        #chipSet
        class="singleTags__chip-set"
      >
        @for(tag of group.items; track tag.id) {
          <ci-suggestion-chip-outline>
            <span 
              slot="label"
              class="chip-set__label"
            >
              @if (isTagNameWithBrackets(tag.name[currentLang])) {
                {{ getTagNameWithoutBrackets(tag.name[currentLang]) }}
                <span style="font-weight: 400;">
                  ({{ getBracketTagContent(tag.name[currentLang]) }})
                </span>
              } @else {
                {{ tag.name[currentLang] }}
              }
            </span>
          </ci-suggestion-chip-outline>
        }
      </ci-chip-set>
    </div>
    
    @if(isGroupSeeMoreButtonVisible(chipSet)) {
      <button 
        class="group__see-more-button"
        (click)="handleSeeMoreClick(group.id, chipSet)"
        [attr.icon-name]="isGroupExpanded(group.id) ? 'upward' : 'downward'" 
        tabindex="0"
      >   
        <span 
          class="see-more-button__title ci-heading-h6-semibold"
          [style.width.px]="isGroupExpanded(group.id) ? 84 : 64"
        >
          {{ (isGroupExpanded(group.id) ? 'Ver menos' : 'Ver más') | translate }}
        </span>
        
        <ci-icon 
          class="see-more-button__arrow-icon"
          type="svg" 
          [attr.name]="isGroupExpanded(group.id) ? 'upward' : 'downward'" 
          scale="1x"
        ></ci-icon>
      </button>
    }
  </section>
}